import React from 'react';

interface DismissibleErrorProps {
  message: string;
  onDismiss: () => void;
  onRetry?: () => void;
}

const DismissibleError: React.FC<DismissibleErrorProps> = ({ message, onDismiss, onRetry }) => (
  <div className="error-message" role="alert">
    <span className="error-body">{message}</span>
    <span className="error-actions">
      {onRetry && (
        <button type="button" className="error-retry" onClick={onRetry}>
          Retry
        </button>
      )}
      <button type="button" className="error-dismiss" onClick={onDismiss} aria-label="Dismiss error">
        Dismiss
      </button>
    </span>
  </div>
);

export default DismissibleError;
